<template>
  <div>
    <v-row class="detail-wrapper work-status">
      <v-col cols="12" class="px-6 py-0">
        <!-- 현황 타이틀  -->
        <sta-title v-on:setSearchParam="doSearch"></sta-title>
        <!-- 현황 카드 -->
        <work-time-sta-card
          v-bind:searchParam="searchParam"
        ></work-time-sta-card>
      </v-col>
    </v-row>
    <!-- 근무현황 리스트 -->
    <work-time-sta-detail
      v-bind:searchParam="searchParam"
    ></work-time-sta-detail>
  </div>
</template>

<script>
/* 근무현황 */
import StaTitle from '@/components/status/StaTitle.vue';
import WorkTimeStaCard from '@/components/status/WorkTimeStaCard.vue';
import WorkTimeStaDetail from '@/components/status/WorkTimeStaDetail.vue';

export default {
  data: () => ({
    searchParam: {}, // 조회파라미터
  }),

  methods: {
    /* 상세항목 초기화 */
    doSearch(param) {
      this.searchParam = param;

      // 공통 스피너 ON
      this.$store.commit('SPINNER/ON_COMMON_SPINNER', 'green');
    },
  },

  created() {
    // 공통 스피너 ON
    this.$store.commit('SPINNER/ON_COMMON_SPINNER', 'green');
  },

  components: {
    StaTitle,
    WorkTimeStaCard,
    WorkTimeStaDetail,
  },
};
</script>

<style>
/* _list.scss 참고 */
.v-btn.btn-detail:not(.v-btn--round).v-size--default {
  min-width: min-content;
}
.detail-wrapper.work-status {
  background-image: url('../../../assets/img/bg_detail_workStatus.png');
  background-size: 223px;
}
</style>
